@if (userSession(); as userSession) {
  @if (userSession.accountManager) {
    <button cdkOverlayOrigin matTooltip="Account manager" (click)="openOverlay()">
      <mat-icon>support_agent</mat-icon>
    </button>
    <ng-template #dialogTemplate>
      <div class="overlay p-3 rounded mat-elevation-z4">
        <div class="text-nowrap">{{ userSession.managerName }}</div>
        <div class="text-nowrap">{{ userSession.managerPhone }}</div>
        <div class="text-nowrap">{{ userSession.managerEmail }}</div>
      </div>
    </ng-template>
  }
}
